<template>
    <pg-page title="Conditie en kracht-training bij Private Gym"
             header="Conditie en kracht-training bij Private Gym"
             id="kracht-en-conditie-training"
    >

        <div class="mx-auto mt-4">
            <div class="row">
                <div class="col-12">
                    <header-and-text-block header-placement="left">
                        <template v-slot:header>
                            Zo'n eiland, hoe werkt dat?
                        </template>
                        Iedereen die traint bij Private Gym kan voor 60, 90 of 120 minuten een eiland reserveren. Daarnaast is één van de grootste
                        voordelen van trainen op je eigen eiland, de tijdbesparing. Doordat je niet hoeft te lopen, niet hoeft te wachten,
                        en niks hoeft te delen, ben je zo klaar. Een training waar je ergens anders anderhalf uur over doet?
                        Binnen 45 minuten klaar op je eigen eiland. Super efficient!
                        <br/>
                        <br/>
                        Ieder eiland is volledig uitgerust als een complete gym. Eigen kettlebells, dumbbells, barbells en meer. Allemaal voor jou.
                    </header-and-text-block>
                </div>
                <div class="col-12">
                    <header-and-text-block header-placement="right">
                        <template v-slot:header>
                            Sterker worden?
                        </template>
                        Niets is zo effectief om sterk te worden dan trainen met vrije gewichten. Functionele training. Precies waar het eiland voor is uitgerust. Je krijgt twee schema's op maat. Hiermee kun je wekelijks gevarieerd trainen en ben je in no-time fit en in shape.
                    </header-and-text-block>
                </div>
                <div class="col-12">
                    <header-and-text-block header-placement="left">
                        <template v-slot:header>
                            Is er begeleiding aanwezig?
                        </template>
                        In een 24/7 gym zal er nooit <em>altijd</em> iemand aanwezig zijn, maar we doen ons best zo vaak mogelijk een gastheer / vrouw op locatie te hebben. Deze kan je dan helpen bij je training. Vragen om advies. Etc. etc. Alles om je zo fijn, efficiënt en effectief mogelijk te laten trainen.
                    </header-and-text-block>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/14.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/11.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/18.jpeg" class="card-img"
                             alt="Private Gym personal training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">

                <div class="col-12">
                    <header-and-text-block header-placement="left">
                        <template v-slot:header>
                            Je conditie verbeteren?
                        </template>
                        Bij conditie denken mensen aan cardio. Maar wist je dat trainen met kettlebells of circuitjes net zo effectief is?
                        Je moet het maar net even weten. Gelukkig staan onze trainers voor je klaar om je hierbij te helpen! Je te helpen meer plezier te vinden in fitness. Zelfverzekerder te worden. Af te vallen. Fitter te worden. Wat je doel ook is. Bij Private Gym kun je er in rust en op jouw manier naartoe werken.
                    </header-and-text-block>
                </div>
                <div class="col-12">
                    <header-and-text-block header-placement="right">
                        <template v-slot:header>
                            Liever cardio?
                        </template>
                        Bij Private Gym staat de conditie en kracht training met vrije gewichten centraal. Functionele training. Waar je in het echte leven ook wat aan hebt. Maar soms is het gewoon lekker om even een uur op een roeier of fiets te zitten. Dat snappen we. Dit deel van de gym wordt steeds uitgebreider. Zo hou je dezelfde rust, maar kun je ook eens wat anders doen.
                    </header-and-text-block>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/9.jpeg" class="card-img"
                             alt="Private Gym kracht training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/22.jpeg" class="card-img"
                             alt="Private Gym kracht training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
                <div class="col-sm-4 my-4">
                    <div class="card bg-dark text-white">
                        <img src="/images/gym/23.jpeg" class="card-img"
                             alt="Private Gym kracht training">
                        <div class="card-img-overlay">
                            <!--                            <h5 class="card-title">Card title</h5>-->
                            <!--                            <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>-->
                            <!--                            <p class="card-text">Last updated 3 mins ago</p>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <header-and-text-block header-placement="right">
                        <template v-slot:header>
                            Geen ervaring met kracht & conditie training?
                        </template>
                        Geen nood. Begeleiding en persoonlijk contact is wat Private Gym naast de eilanden uniek maakt. Wij helpen jou investeren in jezelf. Als je hulp nodig hebt bij de oefeningen, af en toe een nieuw schema wil uitproberen, of nog helemaal nooit gesport hebt - onze trainers staan voor je klaar!
                    </header-and-text-block>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Kom even de sfeer proeven! Plan een rondleiding of stel je vraag via Whatsapp!
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="true" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import RondleidingButton from "../Components/Index/RondleidingButton";
import HeaderAndTextBlock from "../Components/Layout/HeaderAndTextBlock";
import ActionButtons from "../Components/Index/ActionButtons";

export default {
    components: {ActionButtons, HeaderAndTextBlock, RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
